// TODO: remove after fetching options from new endpoint
export const THRIVE_SKIN = "thrive";
export const ORGANISATIONS_SKINS = [
  THRIVE_SKIN,
  "imp-software",
  "vita-coco",
  "delta-star",
  "talisman",
  "dignity",
  "iag-cargo",
  "auto-west-london",
  "huel",
  "succession-wealth",
  "opito",
  "session",
  "sumitomo",
  "stiltz",
  "amber-river",
  "evolve-energy",
  "digital-dewa",
  "newground",
  "curo",
  "mathnasium"
];
